import React from 'react';

export default class ErrorBoundary extends React.Component {
    
    state = { hasError: false };

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error(error, errorInfo);
    }

    render() {
        const { fallback, children } = this.props;
        
        if (this.state.hasError) {
            if (fallback) {
                return fallback;
            }
            // You can render any custom fallback UI
            return (
                <>
                <h1>Sorry, something went wrong. Please try again.</h1>
                <br />
                <p>If the issue persists, check your network connection.</p>
                <br />
                <button className="btnPri button--small" onClick={() => this.setState({ hasError: false })}>Try Again</button>
                </>
            );
        }

        return children;
    }
}